import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const VaultRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings', 'role--settings--vault']}>
    <Route index element={<Index />} />
  </SubRouter>
))
